import type React from 'react';

import { Separator } from '@change-corgi/design-system-legacy/components/content';

import { NewlyCreatedPetitions } from './components/NewlyCreatedPetitions';
import type { Channel } from './components/SuggestedPetitions';
import { SuggestedPetitions as SuggestedPetitionsDefault } from './components/SuggestedPetitions';
import { VictoriousPetitions } from './components/VictoriousPetitions';
import type { SuggestedPetitionSourceLocation } from './shared/types';

type Props = {
	petitionSlugOrId?: string;
	showVictorious?: boolean;
	showNewlyCreated?: boolean;
	channel: Channel;
	/**
	 * For promotion tracking
	 *
	 * e.g. 'search_footer', 'petition_footer', 'update_footer'
	 */
	sourceLocation: SuggestedPetitionSourceLocation;
	className?: string;
};

export type { Props as SuggestedPetitionsProps };

export const SuggestedPetitionsV2: React.FC<Props> = ({
	showVictorious,
	showNewlyCreated,
	petitionSlugOrId,
	channel,
	sourceLocation,
	className,
}) => {
	return (
		<div className={className}>
			<div className="container">
				<SuggestedPetitionsDefault
					petitionSlugOrId={petitionSlugOrId}
					channel={channel}
					sourceLocation={sourceLocation}
				/>
				{showVictorious && (
					<>
						<Separator role="presentation" my={24} />
						<VictoriousPetitions petitionSlugOrId={petitionSlugOrId} sourceLocation={sourceLocation} />
					</>
				)}
				{showNewlyCreated && (
					<>
						<Separator role="presentation" my={24} />
						<NewlyCreatedPetitions petitionSlugOrId={petitionSlugOrId} sourceLocation={sourceLocation} />
					</>
				)}
			</div>
		</div>
	);
};
